export const CONFIG_TYPE = {
	RECOMMEND: 1,
	OPERATE: 2
}
export const SHOW_TYPE = {
	SHOW: '1',
	NOT_SHOW: '0'
}
